import React from "react";

type option = {
  name: string;
  initials: string;
  function: () => void;
  hide?: boolean;
};

type CardsGestionProps = {
  options: option[];
  handleSelectProject: (option: option) => void;
  selectedProject: string | null;
};

const CardsGestion: React.FC<CardsGestionProps> = ({
  options,
  handleSelectProject,
  selectedProject,
}) => {
  return (
    <>
      <ul
        role="list"
        className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 sm:gap-6 lg:grid-cols-3"
      >
        {options.map((option: option) => (
          option.hide ? (
            <li
            key={option.name}
              className="col-span-1 flex rounded-md shadow-sm hover:cursor-pointer"
              onClick={() => {
                handleSelectProject(option);
                option.function();
              }}
            >
              <div
                className={`${
                  selectedProject === option.name
                    ? "bg-primary-600"
                    : "bg-gray-400"
                }  flex w-16 h-16 flex-shrink-0 items-center justify-center rounded-l-md text-sm font-medium text-white`}
              >
                {option.initials}
              </div>
              <div
                className={`flex flex-1 items-center justify-between rounded-r-md border-b border-r border-t ${
                  selectedProject === option.name
                    ? "bg-primary-300 border-primary-200 text-white"
                    : "bg-white border-gray-200 text-gray-900"
                } `}
              >
                <div className="flex-1 px-4 py-2 text-sm">
                  <p className="font-medium">{option.name}</p>
                  <p className="text-gray-500"></p>
                </div>
              </div>
            </li>
          ) : null    
        ))}
      </ul>
    </>
  );
};

export default CardsGestion;
